import { ImgHTMLAttributes } from 'react';
import styled from 'styled-components';
import { BaseStyleProps, base, themed } from '../base';

export interface ImageProps
  extends BaseStyleProps,
    Omit<ImgHTMLAttributes<HTMLImageElement>, 'color' | 'width' | 'height'> {
  src: string;
  alt?: string;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
const ImageWrapper: any = styled('img')(
  {
    display: 'block',
    maxWidth: '100%',
    height: 'auto',
  },
  base as any,
  themed('Image') as any
);
/* eslint-enable @typescript-eslint/no-explicit-any */

const Image = ({ src, alt, m = 0, ...props }: ImageProps) => (
  <ImageWrapper src={src} alt={alt} m={m} {...props} />
);

export default Image;
